import { Link, useNavigate } from "react-router-dom";
import React, { useContext, useEffect, useState } from "react";
import axios from "axios";
import config from "../../config/config";
import { checkUserPermission } from "../../common/UserPermission";
import { Noimage } from "../../common/imagePath";
import moment from "moment";
import HistoryIcon from "@mui/icons-material/History";
import Loader from "../Loader/Loader";
import { AppContext } from "../../context/AppContext";

const HistoryModel = ({ id, model }) => {

  const { isManageSale, isManagePOSSale } = useContext(AppContext);

  const [historyData, setHistoryData] = useState([]);
  const [loading, setLoading] = useState(false);

  const navigate = useNavigate();

  const token = localStorage.getItem("Token");
  const location = localStorage.getItem("Location");
  const LoginId = localStorage.getItem("ID");

  const edithandel = (e) => {
    // navigate(`/manage-Items/${itemsDetailsData?.ItemInfo[0]?.ID}`);
  };

  console.log(historyData, "historyData");

  useEffect(() => {
    if (id > 0) {
      if (model === "sales") {
        setLoading(true);
        axios
          .get(
            `${config.salesconfigBaseUrl}/sales/saleslist?filtercolumnsearchtext=&pagenumber=1&pagesize=10&filtertext=&ordercolumn=&currentorder=desc&startdate=&status=0&enddate=&salestypeid=0&customerid=0&LocationID=${location}&isShowEcomOrders=1&SalePaymentStatus=0&loginId=${LoginId}`,
            {
              headers: {
                "Content-Type": "application/json;charset=UTF-8",
                Authorization: token,
              },
            }
          )
          .then((res) => {
            setHistoryData(res.data.ResponseData?.list);

            setLoading(false);
          })
          .catch((err) => {
            setLoading(false);
          });
      } else {
        setLoading(true);
        axios
          .get(
            `${config.receivingBaseUrl}/receivings/listofalldata?filtercolumnsearchtext=&pagenumber=1&pagesize=10&filtertext=&ordercolumn=&currentorder=desc&startdate=&enddate=&receivingtypeid=0&supplierid=0&status=0&LocationID=${location}&receivePaymentStatus=0&loginId=${LoginId}`,
            {
              headers: {
                "Content-Type": "application/json;charset=UTF-8",
                Authorization: token,
              },
            }
          )
          .then((res) => {
            console.log("listofsuspendrecord", res.data.ResponseData?.list);
            setHistoryData(res.data.ResponseData?.list);
            setLoading(false);
          })
          .catch((err) => {
            setLoading(false);
          });
      }
     
    }
  }, [id]);

  return (
    <>
    <Loader loading={loading} />
      <div
        className="modal fade top-right-modal"
        id="HistoryModel"
        tabIndex={-1}
        data-bs-keyboard="false"
      >
        <div
          className="modal-dialog modal-fullscreen modal-dialog-centered"
          role="document"
        >
          <div className="modal-content" style={{minHeight: '500px'}}>
            <div className="modal-header">
              <p className="modal-title p-lg">
                <HistoryIcon /> {model === "sales" ? 'Recent Transactions' :'Recent Bills'}
              </p>

              <button
                type="button"
                className="close"
                data-bs-dismiss="modal"
                aria-label="Close"
              >
                <span aria-hidden="true">×</span>
              </button>
            </div>
            <div className="modal-body">
              <div className="row">
                <div className="col-md-12">
                  <div className="table-responsive">
                    <table className="table">
                      <thead>
                        <tr>
                          <th className="p-regular">{model === "sales" ? 'Invoice No.' : 'Bill No.'}</th>
                          <th className="p-regular">Created Date</th>
                          <th className="p-regular">Total</th>
                          <th className="p-regular">{model === "sales" ? 'Customer' : 'Supplier'}</th>
                        </tr>
                      </thead>
                      <tbody>
                        {historyData.length > 0 ? (
                          historyData.map((item, index) => (
                            <tr
                              key={index}
                              data-bs-dismiss="modal"
                              aria-label="Close"
                              style={{ cursor: "pointer", color: "blue" }}
                              onClick={() => {
                                navigate(
                                  model === "sales"
                                    ? isManageSale === 1
                                      ? `/manage-sales/${item?.ID}`
                                      : isManagePOSSale === 1
                                      ? `/pos/${item?.ID}`
                                      : "#"
                                    :isManageSale === 1 ? `/manage-receiving/${item?.ReceivingId}` : `/pos-receiving/${item?.ReceivingId}`
                                );
                                
                                // navigate(`${model === "sales" ? `/manage-sales/${item?.ID}` : `/manage-receiving/${item?.ReceivingId}`}`);
                                window.location.reload();
                              }}
                            >
                              <td>{model === "sales" ? item.InvoiceNo : item.ReferenceNo}</td>
                              <td className="word-break-data">
                                {moment(item?.CreatedDate).format("MM-DD-YYYY")}
                              </td>
                              <td style={{ textAlign: "left" }}>
                                {Number(item?.Total).toFixed(2)}
                              </td>
                              <td className="word-break-data">
                                {model === "sales" ? item?.CustomerName : item?.Supplier}
                              </td>
                            </tr>
                          ))
                        ) : (
                          <tr style={{ textAlign: "center", columnSpan: 6 }}>
                            <td>No Data</td>
                          </tr>
                        )}
                      </tbody>
                    </table>
                    <div
                      className="bold"
                      style={{
                        textAlign: "center",
                        borderTop: "1px solid black",
                        paddingTop: "5px",
                      }}
                    >
                      <span
                        className="cursor-pointer"
                        data-bs-dismiss="modal"
                        aria-label="Close"
                        onClick={() => {model === "sales" ? navigate(`/sales`) : navigate(`/receiving`)}}
                      >
                        Show More
                      </span>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default HistoryModel;
